export type AudioStreamRecorderErrorCode =
  | 'not_supported'
  | 'aborted'
  | 'already_used'
  | 'start_error'
  | 'stop_error'
  | 'inactive';

export class AudioStreamRecorderError extends Error {
  public code: AudioStreamRecorderErrorCode;

  constructor(code: AudioStreamRecorderErrorCode, message?: string) {
    super(message || code);
    this.code = code;
  }
}
